import { useEffect } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { getServiceRequest } from "../../redux/apiCalls"
import * as timeago from "timeago.js"
import { format } from "timeago.js"
import fr from "timeago.js/lib/lang/fr"
import en from "timeago.js/lib/lang/en_US"
import { Visibility } from "@mui/icons-material"
// Components
import Table from "../Table/Table"
import Button from "../Button/Button"
// Styles
import {
   Container,
   Wrapper,
   ButtonWrapper,
   Title,
   StyledLink,
} from "./ServiceRequests.styles"

const ServiceRequests = ({ userId }) => {
   const dispatch = useDispatch()
   const { t } = useTranslation()
   timeago.register("fr", fr)
   timeago.register("en", en)
   const requests = useSelector((state) => state.service.requests)
   const user = useSelector((state) => state.user.currentUser)
   const language = useSelector((state) => state.environment.language)

   const formatDate = (date, language) => {
      if (!date) return ""
      return format(date, language)
   }

   const sparePartTranslations = {
      full: t("serviceRequests.value.sparePart.s1"),
      temples: t("serviceRequests.value.sparePart.s2"),
      left: t("serviceRequests.value.sparePart.s3"),
      right: t("serviceRequests.value.sparePart.s4"),
      endtips: t("serviceRequests.value.sparePart.s5"),
      nosepads: t("serviceRequests.value.sparePart.s6"),
   }

   const headers = [
      { name: t("serviceRequests.header.h1"), width: 10, align: "left" },
      { name: t("serviceRequests.header.h2"), width: 20, align: "left" },
      { name: t("serviceRequests.header.h3"), width: 15, align: "left" },
      { name: t("serviceRequests.header.h4"), width: 20, align: "left" },
      { name: t("serviceRequests.header.h5"), width: 15, align: "left" },
      { name: t("serviceRequests.header.h6"), width: 15, align: "center" },
   ]
   let data = []

   for (let i = requests.length - 1; i >= 0; i--) {
      data.push([
         "RQ-SV" + requests[i].requestNumber,
         formatDate(requests[i].requestDate, language),
         sparePartTranslations[requests[i].sparePart],
         requests[i].productRef,
         requests[i].comments,
         <StyledLink to={`/service/${requests[i]._id}`}>
            <Visibility />
         </StyledLink>,
      ])
   }

   useEffect(() => {
      getServiceRequest(userId, dispatch, user?.accessToken)
   }, [userId, dispatch, user])

   return (
      <Container>
         <Wrapper>
            <Title>{t("serviceRequests.title.t1")}</Title>
            <ButtonWrapper>
               <StyledLink to="/new-service">
                  <Button text={t("serviceRequests.button.b1")} width={50} />
               </StyledLink>
            </ButtonWrapper>
         </Wrapper>
         <Table headers={headers} data={data} pageSize={5} />
      </Container>
   )
}

ServiceRequests.propTypes = {
   requests: PropTypes.string,
}

export default ServiceRequests
